import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const MinimizeSvg = ()=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M2.55341 13.0333C2.33848 13.2652 2.35074 13.6287 2.58079 13.8453C2.81085 14.0619 3.17158 14.0495 3.38651 13.8177L6.42379 10.5415V12.3405C6.42379 12.6578 6.67902 12.915 6.99384 12.915C7.30867 12.915 7.5639 12.6578 7.5639 12.3405V9.08519C7.5639 9.01847 7.5526 8.95439 7.53184 8.89479C7.50239 8.80999 7.45268 8.73095 7.383 8.66535C7.26995 8.55887 7.12535 8.50775 6.98199 8.51079H3.97593C3.6611 8.51079 3.40588 8.76799 3.40588 9.08519C3.40588 9.40247 3.6611 9.65967 3.97593 9.65967H5.68103L2.55341 13.0333Z",
                fill: "#676879"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12.024 7.48924C12.3389 7.48924 12.5941 7.23204 12.5941 6.91478C12.5941 6.59751 12.3389 6.34031 12.024 6.34031H10.3186L13.4463 2.96652C13.6613 2.73469 13.649 2.37117 13.419 2.15458C13.1889 1.93798 12.8282 1.95034 12.6133 2.18217L9.57615 5.45815V3.65946C9.57615 3.34219 9.32095 3.08499 9.00615 3.08499C8.69127 3.08499 8.43607 3.34219 8.43607 3.65946V6.89855C8.43167 7.05748 8.49239 7.21747 8.61671 7.33455C8.72655 7.43794 8.86615 7.48916 9.00543 7.48924H12.024Z",
                fill: "#676879"
            })
        ]
    });
export default MinimizeSvg;
